import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
	data: () => ({
		user: null,
		site: null,
		cms6Url: process.env.VUE_APP_JUNIPER_API,
		namespace: null,
		headers: null,
		controller: null,
	}),
	computed: {
		...mapGetters(['authUser', 'tokenJuniper']),
	},
	created() {
		this.prepareForFetch()
	},
	methods: {
		prepareForFetch() {
			this.user = this.authUser
			this.headers = {
				Authorization: 'Bearer ' + this.tokenJuniper,
				'mc2-auth': this.$store.state.juniperApiToken,
				'mc2-user': this.$store.state.authUser?.email,
			}
		},

		async uploadFile(file, clientId, image = false) {
			var formData = new FormData()
			formData.append('file', file)
			formData.append('client_id', clientId)

			if (image) {
				formData.append('image', true)
			}

			this.prepareForFetch()
			return await axios.post(this.cms6Url + `/media`, formData, {
				headers: { ...this.headers, ...{ 'Content-Type': 'multipart/form-data' } },
			})
		},

		async getMediaLibrary(page = 1, perPage = 10, order = 'desc', orderBy = 'date', querySearch = '', onlyImages = false, fileType = false, clientId = null) {
			let params = {
				page: page,
				per_page: perPage,
				order: order, // 'asc'
				orderby: orderBy,
				search: querySearch,
				client_id: clientId,
			}
			if (onlyImages && !fileType) {
				params = { ...params, ...{ media_type: 'image' } }
			}
			if (fileType) {
				params = { ...params, ...{ media_type: fileType } }
			}
			try {
				return await axios.get(this.cms6Url + `/media`, {
					headers: this.headers,
					//signal: this.controller.signal,
					params: params,
				})
			} catch (error) {
				console.log(error)
			}
		},
		async getMedia(id) {
			return await axios.get(this.cms6Url + `/media/${id}`, {
				headers: this.headers,
			})
		},
		async deleteMedia($id) {
			return await axios.delete(this.cms6Url + `/media/${$id}`, {
				headers: this.headers,
			})
		},
	},
}
